import { useAuth } from '@/hooks/use-auth';

function sessionKey(userId: string) {
  return `dp_pp_dismissed_${userId}`;
}

export function useProfileCompletion() {
  const { user, isLoading, isAuthenticated } = useAuth();

  const isProfileComplete = !!(
    user?.personId &&
    (user as any)?.firstName?.trim()
  );

  const wasDismissedThisSession = !!(
    user?.id && sessionStorage.getItem(sessionKey(user.id)) === 'true'
  );

  const shouldShowOnAppOpen =
    isAuthenticated && !isLoading && !isProfileComplete && !wasDismissedThisSession;

  const shouldShowOnRoute =
    isAuthenticated && !isLoading && !isProfileComplete;

  function dismiss() {
    if (user?.id) {
      sessionStorage.setItem(sessionKey(user.id), 'true');
    }
  }

  function clearOnComplete() {
    if (user?.id) {
      sessionStorage.removeItem(sessionKey(user.id));
    }
  }

  return {
    isProfileComplete,
    shouldShowOnAppOpen,
    shouldShowOnRoute,
    wasDismissedThisSession,
    dismiss,
    clearOnComplete,
    isLoading,
    isAuthenticated,
  };
}
